import React from "react";

export function StatusColumnFormatter(
  cellContent,
  row,
  rowIndex,
  { updateStatus, superadmin, processing }
) {
  const isActive =
    row.status === "active" ||
    row.status === 0 ||
    row.status === "0";

  const handleToggle = (e) => {
    e.stopPropagation();
    const newStatus = isActive ? "inactive" : "active";
    updateStatus(row.id, newStatus);
  };

  if (processing === row.id) {
    return <i className="fas fa-circle-notch fa-spin text-primary"></i>;
  }

  if (superadmin) {
    return (
      <div
        className="d-inline-flex align-items-center text-nowrap"
        title={`Status: ${isActive ? "Active" : "Inactive"} (click to toggle)`}
      >
        <span
          style={{
            position: "relative",
            display: "inline-block",
            width: "44px",
            height: "24px",
            cursor: "pointer",
            borderRadius: "24px",
            backgroundColor: isActive ? "#1bc5bd" : "#f64e60", // Green when active, Red when inactive
            transition: "background-color 0.25s ease",
            boxShadow: isActive
              ? "0 0 6px rgba(27, 197, 189, 0.4)"
              : "0 0 6px rgba(246, 78, 96, 0.4)",
          }}
          onClick={handleToggle}
        >
          <span
            style={{
              position: "absolute",
              top: "3px",
              left: isActive ? "23px" : "3px",
              width: "18px",
              height: "18px",
              backgroundColor: "#ffffff",
              borderRadius: "50%",
              transition: "left 0.2s ease",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.25)",
            }}
          ></span>
        </span>
      </div>
    );
  }

  return (
    <div
      className="d-inline-flex align-items-center text-nowrap"
      title={isActive ? "Active" : "Inactive"}
    >
      <span
        style={{
          position: "relative",
          display: "inline-block",
          width: "36px",
          height: "20px",
          borderRadius: "20px",
          backgroundColor: isActive ? "#1bc5bd" : "#f64e60",
          opacity: 0.85,
        }}
      >
        <span
          style={{
            position: "absolute",
            top: "2px",
            left: isActive ? "18px" : "2px",
            width: "16px",
            height: "16px",
            backgroundColor: "#ffffff",
            borderRadius: "50%",
          }}
        ></span>
      </span>
    </div>
  );
}